const initialState = {
    menus: [],
  };
  
  const headerrReducer = (state = initialState, action) => {
    switch (action.type) {
      case "SET_HEADER_MENUS":
        return { ...state, menus: action.payload };
      default:
        return state;
    }
  };
  
  export default headerrReducer;
  